module.exports = {
	"ver": "גרסה",
	"new": "חדש",
	"musketeer": "מוסקטיר",
	"lastIncident": "אירוע אחרון",
	"more": "עוד פרטים",
	"incidentNo": "מס. אירוע",
	"createdBy": "נוצר ע.י.",
	"serviceNeeded": "שירות נדרש",
	"start": "התחלה",
	"eventLocation": "מיקום אירוע",
	"group": "קבוצת",
	"lastWeek": "שבוע אחרון...(הסטוריה)",
	"seeAll": "ראה הכל",
	"createIncident": "צור<br />אירוע",
	"police": "משטרה",
	"fire": "אש",
	"medical": "רפואה",
	"rescue": "הצלה",
	"setLocation": "בחר מקום (הכנס כתובת מדויקת או סמן מיקום במפה )",
	"locationDescription": "תן כותרת לאירוע (תיאור)",
	"create": "צור",
	"close": "סגור",
	"locationRequired": "חובה לבחור מיקום",
	"pointPolygon": "נא לבחור נקודה בתוך הפוליגון!!",
	"createSuccess": "אירוע נוצר בהצלחה.",
	"createFailed": "יצירת יארוע נכשלה!",
	"day": "יום",
	"hr": "שע.",
	"min": "דק.",
	"sec": "שנ.",
	"sendPublic": "שלח הודעה ציבורית",
	"emergencySettings": "הגדרות כיתת כוננות",
	"usersSettings": "הגדרות משתמשים",
	"accountsSettings": "הגדרות חשבונות",
	"incidentHistory": "הסטורית אירועים",
	"projects": "פרויקטים",
	"customers": "לקוחות",
	"rooms": "חדרים",
	"songHistory": "היסטוריית שירים",
	"users": "משתמשים",
	"reports": "דוחות",
	"settings": "הגדרות",
	"logout": "יציאה",
	"language": "שפה",
	"age": "גיל",
	"gender": "מין",
	"address": "כתובת",
	"phone": "טלפון",
	"location": "מיקום",
	"conditions": "תנאים",
	"description": "תיאור",
	"incidentInfo": "פרטי אירוע",
	"at": "ב",
	"or": "או",
	"sendMessage": "שלח הודעה",
	"mediaAttached": "קבצים מצורפים",
	"inviteMusketeers": "הזמן מוסקטיר",
	"resolveIncident": "סגור<br />אירוע",
	"resolveIncidentTitle": "סגור אירוע",
	"resolveSummary": "נא לכתוב סיכום אירוע",
	"reason": "סיבה",
	"resolvedBy": "נסגר ע.י.",
	"resolved": "Activity resolved.",
	"typeMessage": "כתוב הודעה",
	"resolve": "סגור",
	"resolveMistake": "טעות",
	"resolveOthers": "עזרה על ידי אחרים",
	"resolveMusketeers": "עזרה על ידי מוסקטירים",
	"resolveNoHelp": "לא קבל עזרה",
	"resolveTesting": "בדיקות",
	"history": "הסטוריה",
	"prev": "הקודם",
	"next": "הבא",
	"sendPublicMsg": "שלח הודעה ציבורית",
	"sendPublicMsgIntro": "אתה יכול לשלוח הודעה לכל המוסקטירים בשדה המוגדרת לחשבון שלך.",
	"sendTo": "שלח אל",
	"msgType": "סוג הודעה",
	"security": "בטחון",
	"successStory": "ספור הצלחה",
	"social": "חברתי",
	"defaultLanguage": "שלח בשפת ברירת מחדל",
	"english": "אנגלית",
	"hebrew": "עברית",
	"spanish": "ספרדית",
	"controlArea": "איזור שליטה",
	"definePolygon": "פוליגון מוגדר",
	"serviceUsers": "משתמשי שירות",
	"addFile": "הוסף קובץ",
	"subject": "נושא",
	"yourMsg": "כתוב הודעה",
	"newMsg": "הודעה חדשה",
	"send": "שלח",
	"imageOnly": "נא לבחור קובץ תמונה בלבד!!",
	"uploadImageSuccess": "Upload image success.",
	"uploadImageFailed": "העלאת תמונה נכשלה! ההודעה לא נשלחה!",
	"createContentFailed": "HE-Message failed! Could not create content!",
	"missingSubjectMessage": "HE-Please enter subject and message in all tabs!",
	"missingUsers": "HE-No users to send to!!",
	"messageSend": "HE-Message was sent.",
	"messageFailed": "HE-Message failed!!",
	"response": "התגובה שלך...",
	"emergencySetting": "הגדרת כיתת כוננים",
	"emergencySettingIntro": "אתה יכול להגדיר עד 10 musketeers בתור Stand-by, הם יקבלו התראות כאשר יש להתקשר כדי לעזור באזור מוגדר עבור החשבון שלך",
	"addMusketeer": "הוסף מוסקטיר",
	"userName": "שם משתמש",
	"email": "מייל",
	"account": "חשבון",
	"date": "תאריך",
	"noMusketeers": "No Musketeers !!",
	"musketeerDeleted": "Musketeer was deleted.",
	"musketeerDeleteFailed": "Failed to delete musketeer!",
	"maxMusketeer": "Max 10 musketeer exceded !!",
	"add": "הוסף",
	"invite": "הזמן",
	"musketeerExists": "This Musketeer already exists!",
	"inviteSuccess": "Invite success.",
	"inviteFailed": "Invite failed!",
	"missingMusketeer": "Please enter musketeer name or phone number!",
	"phoneNumber": "insert phone number",
	"musketeerName": "הכנס שם מוסקטיר",
	"usersSetting": "הגדרת משתמשים",
	"createUser": "צור משתמש",
	"editUser": "עדכן משתמש",
	"uploadPhoto": "העלאת תמונת משתמש",
	"replacePhoto": "החלף תמונה",
	"save": "שמור",
	"userSuccess": "משתמש נוצר בהצלחה.",
	"userFailed": "יצירת משתמש נכשלה!",
	"userUpdateSuccess": "Update user success.",
	"userUpdateFailed": "Update user failed!!",
	"updatePasswordFailed": "Update password failed!",
	"correctPassword": "Please enter correct password!",
	"noUsers": "No Users !!",
	"missingEmail": "* Please enter email address",
	"newPassword": "New Password",
	"confirmPassword": "Confirm Password",
	"disableUser": "Disable User",
	"enableUser": "Enable User",
	"deleteUser": "Delete User",
	"accountsSetting": "הגדרת חשבונות",
	"createAccount": "צור חשבון",
	"accountName": "שם חשבון",
	"dateCreated": "תאריך יצירה",
	"noAccounts": "אין חשבונות !!",
	"accountDetails": "פרטי חשבון",
	"controlCities": "ערי שליטה",
	"controlAreas": "אזורי שליטה",
	"communityId": "קוד סביבה",
	"newAccount": "חשבון חדש",
	"editAccount": "עריכת חשבון",
	"enableAccount": "הפעלת חשבון",
	"disableAccount": "ביטול חשבון",
	"deleteAccount": "מחיקת חשבון",
	"joinKey": "מפתח",
	"alertType": "סוג התראה",
	"uploadLogo": "העלאת לוגו",
	"logo": "לוגו",
	"name": "שם",
	"assistance": "עזרה",
	"selectCountries": "נא לבחור מדינות וערים לחשבון שלך",
	"country": "מדינה",
	"city": "עיר",
	"selectPolygon": "נא לבחור פוליגון לחשבון שלך",
	"missingName": "נא הכנס שם!",
	"missingCommunity": "נא הכנס קוד!",
	"updateAccountSuccess": "חשבון עודכן בהצלחה.",
	"updateAccountFailed": "עדכון חשבון נכשל!",
	"createAccountSuccess": "חשבון נוצר בהצלחה.",
	"createAccountSuccessNoUser": "חשבון נוצר בהצלחה. אך יצירת משתמש נכשלה!",
	"deleteAccountSuccess": "חשבון נמחק בהצלחה.",
	"deleteAccountFailed": "מחיקת חשבון נכשלה!!",
	"enableAccountSuccess": "חשבון הופעל בהצלחה",
	"enableAccountFailed": "הפעלת חשבון נכשלה!!",
	"disableAccountSuccess": "חשבון בוטל בהצלחה.",
	"disableAccountFailed": "ביטול חשבון נכשל!!",
	"newEvent": "אירוע חדש",
	"resolvedEvent": "אירוע נסגר",
	"playlist": "Playlist"
};


//////////////////
// WEBPACK FOOTER
// ./src/langs/hebrew.json
// module id = 381
// module chunks = 2